import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { getLastResults, getDetailResults } from '../../../../apiservices/CasionApi';
import RefResultModal from '../../../casinoComponents/refResultModal';
import Teen9ResultBody from '../../../casinoComponents/refResultModal/Teen9ResultBody';
import { formatRefMatchTime } from '../../../../utils/refMatchTime';

const WIN_CLASS = { 1: 'resulta', 2: 'resultb', 3: 'resultc', 0: 'resulttie' };

/**
 * Teenpatti Test (teen9) "Last Result" items in the reference markup (inside CasinoLastResult's
 * .casino-video-last-results): span.resulta "T" / .resultb "L" / .resultc "D" (/ .resulttie "T").
 * Click → full-page .loader-overlay (in .page-content) while the round detail loads,
 * then the reference result modal (RefResultModal + Teen9ResultBody).
 */
const Teen9LastResults = ({ data = [], gameType = 'teen9', mid }) => {
  const [showModal, setShowModal] = useState(false);
  const [lastResults, setLastResults] = useState([]);
  const [detailResult, setDetailResult] = useState(null);
  const [loading, setLoading] = useState(false);

  // Reference: reload the last results when the round (mid) changes; our backend can publish the
  // result a little after the new round starts, so also poll.
  useEffect(() => {
    let alive = true;
    const fetchLastResults = async () => {
      try {
        const response = await getLastResults(gameType);
        if (alive && response?.data?.data?.res) setLastResults(response.data.data.res);
      } catch (error) {
        console.error('Error fetching last results:', error);
      }
    };
    fetchLastResults();
    const interval = setInterval(fetchLastResults, 5000);
    return () => {
      alive = false;
      clearInterval(interval);
    };
  }, [gameType, mid]);

  const handleResultClick = async (resultItem) => {
    const rid = resultItem?.mid;
    if (!rid) return;
    setDetailResult(null);
    setLoading(true);
    try {
      const response = await getDetailResults(gameType, rid.toString());
      const t1 = response?.data?.data?.t1 ?? response?.data?.t1;
      if (t1) setDetailResult(t1);
    } catch (error) {
      console.error('Error fetching detail results:', error);
    } finally {
      setLoading(false);
      setShowModal(true);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setDetailResult(null);
  };

  const allResults = lastResults.length > 0
    ? lastResults
    : data.map((res) => ({ win: res?.win ?? res, mid: res?.mid ?? null }));

  return (
    <>
      {allResults.map((resultItem, index) => {
        const win = String(resultItem?.win ?? '');
        return (
          <span
            key={index}
            className={WIN_CLASS[win]}
            onClick={() => handleResultClick(resultItem)}
          >
            {win === '1' && 'T'}{' '}{win === '2' && 'L'}{' '}{win === '3' && 'D'}{' '}{win === '0' && 'T'}
          </span>
        );
      })}
      {loading && createPortal(<div className="loader-overlay" />, document.querySelector('.page-content') || document.body)}
      <RefResultModal
        show={showModal && !loading && !!detailResult}
        onHide={handleCloseModal}
        title="Teenpatti Test Result"
        roundId={detailResult?.rid ?? detailResult?.mid}
        matchTime={formatRefMatchTime(detailResult?.mtime)}
      >
        <Teen9ResultBody t1={detailResult} />
      </RefResultModal>
    </>
  );
};

export default Teen9LastResults;
